import { useEffect, useState } from "react";

let applePaySdkPromise: Promise<boolean> | null = null;

function loadApplePaySdk(): Promise<boolean> {
    if (typeof window === "undefined") {
        return Promise.resolve(false);
    }

    if (applePaySdkPromise) {
        return applePaySdkPromise;
    }

    applePaySdkPromise = new Promise<boolean>(resolve => {
        const script = document.createElement("script");
        script.id = "apple-pay-sdk";
        script.src = "https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js";
        script.crossOrigin = "anonymous";
        script.onload = () => {
            resolve(!!(window.ApplePaySession && ApplePaySession.canMakePayments()));
        };
        script.onerror = () => {
            applePaySdkPromise = null;
            resolve(!!(window.ApplePaySession && ApplePaySession.canMakePayments()));
        };
        document.head.appendChild(script);
    });

    return applePaySdkPromise;
}

export const useApplePaySdk = (merchantId: string | undefined) => {
    const [isApplePayAvailable, setIsApplePayAvailable] = useState(false);

    useEffect(() => {
        if (!merchantId) {
            return;
        }

        let cancelled = false;
        loadApplePaySdk().then(available => {
            if (!cancelled) {
                setIsApplePayAvailable(available);
            }
        });
        return () => {
            cancelled = true;
        };
    }, [merchantId]);

    return isApplePayAvailable;
};
